import "./App.scss";
import FileUploader from "./components/FileUploader";

function App() {
	return (
		<div className="App">
			<FileUploader></FileUploader>
		</div>
	);
}

export default App;
